import i18n from "@/i18n/config"

export const DefaultStartText = i18n.t(
  "editor.inspect.setter_default_value.recording.start_button_text",
)
export const DefaultStopText = i18n.t(
  "editor.inspect.setter_default_value.recording.stop_button_text",
)
export const DefaultClearText = i18n.t(
  "editor.inspect.setter_default_value.recording.clear_button_text",
)
export const RecordPermission = i18n.t(
  "editor.inspect.setter_message.recording.recording_permission",
)
export const SetValueMessage = i18n.t(
  "editor.inspect.setter_message.recording.cannot_set_value_dur",
)
